import { Typography } from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
import { IOrderDetailsResponse } from '../../../models/order-details';
import { IPoJobNameButton } from '../../../models/purchase-history/table';
import { PoJobNameModal } from './index';

export const PoJobNameButton = ({ order, setAlertState }: IPoJobNameButton) => {
  const isPoJobNameMatchingOrderNumber: boolean =
    order?.POJobName !== undefined &&
    order?.orderNumbers?.[0] !== undefined &&
    order?.POJobName === order?.orderNumbers?.[0];

  const isPoJobNameEmpty: boolean =
    order.POJobName === '' || order.POJobName === undefined;

  const initPoJobName =
    isPoJobNameMatchingOrderNumber || isPoJobNameEmpty
      ? 'Add PO/Job Name'
      : order?.POJobName;

  const [openModal, setOpenModal] = useState(false);
  const [visiblePoJobName, setVisiblePoJobName] = useState<string>(
    initPoJobName ?? '',
  );

  return (
    <>
      <button
        type="button"
        className="sui-underline sui-text-sm hover:sui-no-underline sui-text-ellipsis sui-overflow-hidden sui-h-[44px] sui-text-left sui-w-[124px]"
        onClick={() => setOpenModal(true)}
      >
        <Typography variant="body-base">
          {visiblePoJobName?.length > 15
            ? `${visiblePoJobName?.slice(0, 12)}...`
            : visiblePoJobName}
        </Typography>
      </button>
      {openModal && (
        <PoJobNameModal
          page="purchaseHistory"
          order={order as unknown as IOrderDetailsResponse}
          openModal={openModal}
          setOpenModal={setOpenModal}
          visiblePoJobName={visiblePoJobName}
          setVisiblePoJobName={setVisiblePoJobName}
          setAlertState={setAlertState}
        />
      )}
    </>
  );
};
